/**
 * InstallExtensionDialog — install guidance shown when the landlord is in desktop Chrome without
 * the Resida extension and chooses a Post action (BR-27, US-6).
 */
import { extensionStoreUrl } from '../../lib/listing-extension-bridge';
import { LISTING_SITE_LABELS, type ListingSiteDto } from '../../lib/external-listing-posts.api';
import { buttonVariants } from '../ui/button-variants';
import { Button } from '../ui/button';
import { Modal } from '../Modal';

interface InstallExtensionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  /** The site the landlord chose, so the "come back" sentence names it. */
  site: ListingSiteDto;
}

export function InstallExtensionDialog({ isOpen, onClose, site }: InstallExtensionDialogProps) {
  const storeUrl = extensionStoreUrl();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Install the Resida extension first"
      width="medium"
      data-testid="install-extension-dialog"
    >
      <div className="space-y-4 text-sm text-foreground">
        <p>
          It fills Facebook Marketplace and Craigslist forms from this listing, photos included. It takes about a
          minute, once.
        </p>
        <ol className="list-decimal space-y-2 pl-5">
          <li>
            <strong>Add it to Chrome</strong> from the Chrome Web Store.
          </li>
          <li>
            <strong>Pin it</strong>: click the puzzle icon in Chrome&apos;s toolbar, then the pin next to Resida.
          </li>
          <li>
            <strong>Connect</strong>: open the extension and sign in to Resida.
          </li>
        </ol>
        <p className="text-muted-foreground">Then come back and choose Post to {LISTING_SITE_LABELS[site]} again.</p>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <Button type="button" variant="outline" onClick={onClose} data-testid="install-extension-dismiss">
            Not now
          </Button>
          {storeUrl && (
            <a
              href={storeUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="install-extension-link"
              className={buttonVariants()}
            >
              Add to Chrome ↗
            </a>
          )}
        </div>
      </div>
    </Modal>
  );
}
